import Vue from 'vue';
import { sessionCountStore } from '@/stores/sessionCountStore';
export default Vue.extend({
    name: 'SessionCountSettings',
    props: {
        mode: {
            type: String,
            default: 'standalone',
            validator: (v) => ['standalone', 'embedded'].includes(v),
        },
    },
    data() {
        return {
            isOpen: false,
            sessionCountStore
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        async selectOption(value) {
            await sessionCountStore.updateSessionsPerPage(value);
            this.closeDropdown();
            // Emit event for parent components to know about the change
            this.$emit('sessions-per-page-changed', value);
        }
    },
    // Close dropdown when clicking outside
    mounted() {
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.closeDropdown();
            }
        });
    }
});
